import { Term } from './AutocompleteTermStore';
export class AutocompleteHistoryStore extends Array {
    static get [Symbol.species]() {
        return Array;
    }
    constructor(services, queries, resetTerms, rootState) {
        const terms = [];
        queries?.map((query) => {
            terms.push(new Term(services, {
                active: false,
                value: query,
            }, terms, resetTerms, rootState));
        });
        super(...terms);
    }
}
